/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {AssetStatusFilter} from '@ion/dls/src/filters/AssetStatusFilter';
import {Filters} from '@ion/dls/src/types/types';
import {FilterParamsType} from '../types';

interface StatusFilterParamsType extends FilterParamsType {}

export const StatusFilter = ({
  isPhone,
  toggleView,
  filterState,
  handleSubmit,
  globalGroupId
}: StatusFilterParamsType) => (
  <AssetStatusFilter isMobileView={isPhone}
    elementId='status-filter'
    name={Filters.assetStatus}
    onCancel={toggleView}
    onMenuClose={toggleView}
    filterState={filterState[Filters.assetStatus]}
    onSubmit={handleSubmit}
    accountId={globalGroupId} />
);

export default StatusFilter;
